/**
 * StatsCard — reusable stats card used across all dashboards.
 *
 * Props:
 *   title   - card title (e.g. "Wallet Balance")
 *   value   - main value to display
 *   subtitle - small text below value
 *   icon    - Lucide icon component
 *   iconColor - tailwind text color class (e.g. "text-blue-600")
 */
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';

const StatsCard = ({ title, value, subtitle, icon: Icon, iconColor = 'text-blue-600' }) => (
    <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">{title}</CardTitle>
            {Icon && <Icon className={`h-4 w-4 ${iconColor}`} />}
        </CardHeader>
        <CardContent>
            <div className="text-2xl font-bold">{value}</div>
            {subtitle && <p className="text-xs text-gray-600">{subtitle}</p>}
        </CardContent>
    </Card>
);

export default StatsCard;
